import { render, staticRenderFns } from "./Podiums.vue?vue&type=template&id=bf6ecc12&scoped=true&"
import script from "./Podiums.vue?vue&type=script&lang=js&"
export * from "./Podiums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6ecc12",
  null
  
)

export default component.exports